var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { useAlerts } from '../components/molecules/Alerts';
import { MAFIA_CONFLICT_ERROR } from '../types/errors';
import { getAlertError, getAlertSuccess, getMafiaErrors } from '../utils';
import { E_ALERT } from '../types/AlertTypes';
import { useAppDispatch } from '.';
import { setMatchState } from '../store/match';
import { getMatchState } from '../api/matches';
export const useErrorHandler = (matchId) => {
    const { setAlerts } = useAlerts();
    const dispatch = useAppDispatch();
    const refreshMatchState = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        try {
            const freshState = yield getMatchState(matchId);
            dispatch(setMatchState(freshState));
        }
        catch (e) {
            console.error('Failed to refresh match state:', e);
            throw e;
        }
    });
    const errorHandler = (err) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!axios.isAxiosError(err))
            return;
        const status = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
        // Специальная обработка 409 Conflict
        if (status === MAFIA_CONFLICT_ERROR) {
            try {
                // 1. Сначала обновляем состояние
                yield refreshMatchState();
                // 2. ПОСЛЕ обновления показываем Info Alert
                setAlerts([{
                        type: E_ALERT.INFO,
                        message: 'Состояние игры обновлено'
                    }]);
            }
            catch (refreshError) {
                // Если не удалось обновить состояние - показываем ошибку
                setAlerts([{
                        type: E_ALERT.ERROR,
                        message: 'Не удалось обновить состояние игры'
                    }]);
            }
            return;
        }
        // Для остальных ошибок - стандартная обработка
        const errors = getMafiaErrors(err);
        if (errors) {
            setAlerts(errors);
        }
    });
    const setError = (message) => setAlerts(getAlertError(message));
    const setSuccess = (message) => setAlerts(getAlertSuccess(message));
    return {
        errorHandler,
        setError,
        setSuccess,
    };
};
